var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IcmImportConfig_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { ImportConfig, ImportConfigType } from './importConfig';
import { icmImportConfigSchemaValidation } from '../../validations.generated';
export var IcmSourceType;
(function (IcmSourceType) {
    IcmSourceType["Calculation"] = "calculation";
    IcmSourceType["CustomTable"] = "customTable";
    IcmSourceType["DataStore"] = "dataStore";
})(IcmSourceType || (IcmSourceType = {}));
export const icmImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:IcmImportConfig',
    type: 'object',
    properties: {
        apiKey: { type: 'string', minLength: 1 },
        model: { type: 'string', minLength: 1 },
        domainName: { type: 'string', minLength: 1 },
        sourceType: {
            type: 'string',
            enum: Object.values(IcmSourceType)
        },
        tablename: { type: 'string', minLength: 1 },
        calculationID: { type: 'string', minLength: 1 },
        dataStoreID: { type: 'string', minLength: 1 }
    },
    // sourceType determines required ID type
    if: { properties: { sourceType: { const: IcmSourceType.Calculation } }, required: ['sourceType'] },
    then: { required: ['calculationID'] },
    else: {
        if: { properties: { sourceType: { const: IcmSourceType.CustomTable } }, required: ['sourceType'] },
        then: { required: ['tablename'] },
        else: {
            if: { properties: { sourceType: { const: IcmSourceType.DataStore } }, required: ['sourceType'] },
            then: { required: ['dataStoreID'] }
        }
    },
    required: ['sourceType']
};
let IcmImportConfig = IcmImportConfig_1 = class IcmImportConfig extends ImportConfig {
    // Not the most elegant constructor signature.
    // In a proper design, this should be 2 subclasses of an abstract parent IcmImportConfig,
    // but everything works under the assumption that ImportConfig classes and external data
    // services are 1-to-1, so calc and custom table imports are lumped into one object.
    constructor(sourceType, calculationID, tablename, dataStoreID, columnsToUpdate) {
        super(ImportConfigType.Icm, columnsToUpdate);
        this.sourceType = sourceType;
        this.calculationID = calculationID;
        this.tablename = tablename;
        this.dataStoreID = dataStoreID;
        JSON.validate(this, IcmImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
    get isParquetImport() {
        return true;
    }
};
IcmImportConfig = IcmImportConfig_1 = __decorate([
    JsonSchemaV2(icmImportConfigSchema, icmImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.Icm)
], IcmImportConfig);
export { IcmImportConfig };
//# sourceMappingURL=icmImportConfig.js.map